import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'AB',
    name: 'The Reliquary',
    id: 'TheReliquary',
    health: 70,
    difficulty: 6,
    expeditionRating: 3,
    additionalInfo: '',
  },
]